exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cookie-manager-main-container .my-panel{position:fixed;z-index:99999999;bottom:0;left:0;width:100%;padding:5px;background:#000;color:#fff}.cookie-manager-main-container .fullwidth{width:100%}.cookie-manager-main-container .btn.btn-primary{height:32px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--2-2!./node_modules/sass-loader/lib/loader.js!./src-cookie-manager/views/bottom-info-panel/style.scss
// module id = 415
// module chunks = 0